<template>
  <Head title="Sign In" />
  <div
    class="from-navy-50 to-navy-100 relative flex min-h-screen items-center justify-center bg-gradient-to-br via-neutral-50 px-4 py-12 sm:px-6 lg:px-8"
  >
    <div
      class="from-navy-500/5 absolute inset-0 bg-gradient-to-br to-green-500/10"
    ></div>

    <div class="relative z-10 w-full max-w-md">
      <div class="rounded-2xl bg-white p-8 shadow-xl">
        <div class="mb-8 text-center">
          <img
            src="/assets/trellis-logo.svg"
            alt="Trellis"
            class="mx-auto mb-4 h-10 w-auto"
          />
          <p class="text-navy-500 text-sm">Digital Closing Platform</p>
        </div>

        <form class="space-y-6" @submit.prevent="form.post('/session')">
          <AppInput
            v-model="form.email"
            label="Email Address"
            type="email"
            placeholder="Enter your email address"
            :error="form.errors.email"
            required
          />

          <AppInput
            v-model="form.password"
            label="Password"
            type="password"
            placeholder="Enter your password"
            :error="form.errors.password"
            required
          />

          <AppButton type="submit" :loading="form.processing" class="w-full">
            Sign In
          </AppButton>
        </form>

        <div class="mt-6 text-center">
          <a
            href="/passwords/new"
            class="text-sm text-green-600 hover:text-green-700"
          >
            Forgot your password?
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Head, useForm } from "@inertiajs/vue3"

import AppButton from "../../components/ui/AppButton.vue"
import AppInput from "../../components/ui/AppInput.vue"
import { SignInFormType } from "./types"

const { email: propEmail } = defineProps<{ email: string }>()

const form = useForm<SignInFormType>({
  email: propEmail || "",
  password: "",
})

defineOptions({ layout: false })
</script>
